module.exports = flarum.core.compat['utils/stringToColor'];